export var SOURCE_SYSTEM = function (SOURCE_SYSTEM) {
  SOURCE_SYSTEM["BART"] = "BART";
  SOURCE_SYSTEM["OPERA"] = "OPERA";
  return SOURCE_SYSTEM;
}({});